<div *ngIf="isProgress else resultBlock" class="text-center">
  <gp-message [text]="inProgressMessage | translate" type="info"></gp-message>
  <div class="app-loading">
    <div class="spinner">
      <span class="gp-spinner"></span>
    </div>
  </div>
</div>

<ng-template #resultBlock>
  <div class="text-center">
    <gp-message *ngIf="isSuccess" [text]="getSuccessMessage() | translate" type="success"></gp-message>
    <gp-message *ngIf="isError" [text]="errorMessage | translate" type="danger"></gp-message>
  </div>

  <div class="text-center">
    <a href="/ui" class="text-center">« {{backToDashboardMessage | translate}}</a>
  </div>
</ng-template>


